// extracted by mini-css-extract-plugin
export default {"hidden":"hidden-T0IKVK","disabled":"disabled-uABDUk"};